<template>
  <div class="home">
      <!-- <link rel="stylesheet" href="https://awshk.handycdn.com/css/bootstrap.min.css" /> -->
      <!-- <link rel="stylesheet" href="https://awshk.handycdn.com/css/style.css" /> -->
      <!-- <link rel="stylesheet" href="https://awshk.handycdn.com/css/responsive.css" /> -->
      <!-- <link rel="stylesheet" href="https://awshk.handycdn.com/css/colors.css" /> -->
      <!-- <link rel="stylesheet" href="https://awshk.handycdn.com/css/animate.css" /> -->
      <!-- <link rel="stylesheet" href="https://fontawesome.dashgame.com/assets/font-awesome/css/font-awesome.css" /> -->
      
      <header class="header header_style1">
         <div class="container">
            <div class="row">
               <div class="col-md-9 col-lg-10">
                  <div class="logo"><a href="index.html"><img src="../assets/template/images/logo.png" alt="#" /></a></div>
                  <div class="main_menu float-right">
                     <div class="menu">
                        <ul class="clearfix">
                           <li class="active"><a href="index.html">Home</a></li>
                           <!-- <li><a href="about.html">About</a></li>
                           <li><a href="service.html">Service</a></li>
                           <li><a href="screenshots.html">Screenshots</a></li>
                           <li><a href="pricing.html">Pricing</a></li>
                           <li><a href="team.html">Team</a></li>
                           <li><a href="contact.html">Contact</a></li>   -->
                           <li><a href="./privacyPolicy">Privacy policy</a></li>
                           <li><a href="./userAgreement">User agreement</a></li>
                        </ul>
                     </div>
                  </div>
               </div>
               <div class="col-md-3 col-lg-2">
                  <div class="right_bt"><a class="bt_main" href="index.html">Get Support</a> </div>
               </div>
            </div>
         </div>
      </header>
      <section id="banner_parallax" class="slide_banner1">
         <div class="container">
            <div class="row">
               <div class="col-md-6">
                  <div class="full">
                     <div class="slide_cont">
                        <h2>Familiarize Your Creative Application</h2>
                        <p>Sed ut perspiciatis unde omnis iste natus error sit voluptatem accusantium doloremque laudantium..!</p>
                        <div class="full slide_bt">
                           <a class="white_bt bt_main download_bt ios" href="https://testflight.apple.com/join/YpaDTyL3" style="margin-right:5px;"><i class="fa fa-apple" style="transition: unset;transform: translateY(1px);font-size:18px;"></i> Apple</a>
                           <a class="white_bt bt_main download_bt android" href="http://d.firim.pro/pwnc"><i class="fa fa-android" style="transition: unset;font-size:18px;"></i> Android</a>
                        </div>
                     </div>
                  </div>
               </div>
               <div class="col-md-6">
                  <div class="full">
                     <div class="slide_pc_img wow fadeInRight" data-wow-delay="1s" data-wow-duration="2s"> <img src="../assets/template/images/pc-banner.png" alt="#" /> </div>
                  </div>
               </div>
            </div>
         </div>
      </section>
      <!-- end header -->
      <!-- section -->
      <section class="layout_padding padding_top_0">
         <div class="container">
            <div class="row margin_bottom_30">
               <!-- featured cont -->
               <div class="col-md-6 cont_theme_blog">
                  <div class="full">
                     <h3>Unique app with different features</h3>
                     <p>Sed ut perspiciatis unde omnis iste natus error sit voluptatem accusantium doloremque laudantium, totam rem aperiam, eaque ipsa quae ab illo inventore veritatis et quasi architecto beatae vitae dicta sunt explicabo.<br><br>Ut enim ad minima veniam quis nostrum exercitationem ullam corporis..!</p>
                  </div>
               </div>
               <!-- end featured cont -->
               <!-- featured image -->
               <div class="col-md-6 wow fadeInRight" data-wow-delay="0.5" data-wow-duration="1s">
                  <div class="full">
                     <div class="center"><img src="../assets/template/images/ser1.png" alt="#" /></div>
                  </div>
               </div>
               <!-- end featured image -->
            </div>
            <div class="row margin_bottom_30">
               <!-- featured image -->
               <div class="col-md-6 wow fadeInLeft" data-wow-delay="0.5" data-wow-duration="1s">
                  <div class="full">
                     <div class="center"><img src="../assets/template/images/ser2.png" alt="#" /></div>
                  </div>
               </div>
               <!-- end featured image -->
               <!-- featured cont -->
               <div class="col-md-6 cont_theme_blog">
                  <div class="full">
                     <h3>Why it’s best app for your business</h3>
                     <p>Sed ut perspiciatis unde omnis iste natus error sit voluptatem accusantium doloremque laudantium, totam rem aperiam, eaque ipsa quae ab illo inventore veritatis et quasi architecto beatae vitae dicta sunt explicabo.<br><br>Ut enim ad minima veniam quis nostrum exercitationem ullam corporis..!</p>
                  </div>
               </div>
               <!-- end featured cont -->
            </div>
            <div class="row margin_bottom_30">
               <!-- featured cont -->
               <div class="col-md-6 cont_theme_blog">
                  <div class="full">
                     <h3>Auricle integrated all populatar tools</h3>
                     <p>Sed ut perspiciatis unde omnis iste natus error sit voluptatem accusantium doloremque laudantium, totam rem aperiam, eaque ipsa quae ab illo inventore veritatis et quasi architecto beatae vitae dicta sunt explicabo.<br><br>Ut enim ad minima veniam quis nostrum exercitationem ullam corporis..!</p>
                  </div>
               </div>
               <!-- end featured cont -->
               <!-- featured image -->
               <div class="col-md-6 wow fadeInRight" data-wow-delay="0.5" data-wow-duration="1s">
                  <div class="full">
                     <div class="center"><img src="../assets/template/images/ser3.png" alt="#" /></div>
                  </div>
               </div>
               <!-- end featured image -->
            </div>
         </div>
      </section>
      <!-- end section -->
      <!-- section -->
      <section class="layout_padding gradiant_bg cross_layout">
         <div class="container">
            <div class="row">
               <div class="col-md-4">
                  <div class="information_blogs">
                     <div class="imf_icon"><img src="../assets/template/images/icon1.png" alt="#" /></div>
                     <div class="imf_head">
                        <h3>Awesome Features</h3>
                     </div>
                     <div class="imf_cont">
                        <p>Sed ut perspiciatis unde omnis iste natus error sit voluptatem accusa ntium</p>
                     </div>
                     <div class="imf_read"><a href="#">Read More</a></div>
                  </div>
               </div>
               <div class="col-md-4">
                  <div class="information_blogs">
                     <div class="imf_icon"><img src="../assets/template/images/icon2.png" alt="#" /></div>
                     <div class="imf_head">
                        <h3>Creative Design</h3>
                     </div>
                     <div class="imf_cont">
                        <p>Sed ut perspiciatis unde omnis iste natus error sit voluptatem accusa ntium</p>
                     </div>
                     <div class="imf_read"><a href="#">Read More</a></div>
                  </div>
               </div>
               <div class="col-md-4">
                  <div class="information_blogs">
                     <div class="imf_icon"><img src="../assets/template/images/icon3.png" alt="#" /></div>
                     <div class="imf_head">
                        <h3>24 Hours Supports</h3>
                     </div>
                     <div class="imf_cont">
                        <p>Sed ut perspiciatis unde omnis iste natus error sit voluptatem accusa ntium</p>
                     </div>
                     <div class="imf_read"><a href="#">Read More</a></div>
                  </div>
               </div>
            </div>
         </div>
      </section>
      <!-- end section -->
      <!-- section -->
      <section class="layout_padding layer_style">
         <div class="container">
            <div class="row">
               <div class="col-sm-12">
                  <div class="full text_align_center">
                     <div class="heading_main center_head_border heading_style_1">
                        <h2>Auricle <span>Features</span></h2>
                     </div>
                  </div>
               </div>
            </div>
            <div class="row app-features">
               <div class="col-md-4 col-sm-6 col-xs-12">
                  <ul class="features-left">
                     <li>
                        <i class="flaticon-wordpress-logo"></i>
                        <div class="fl-inner">
                           <h4>WordPress Installation</h4>
                           <p>Lorem Ipsum dolroin gravida nibh vel velit auctor aliquet. </p>
                        </div>
                     </li>
                     <li>
                        <i class="flaticon-windows"></i>
                        <div class="fl-inner">
                           <h4>Browser Compatible</h4>
                           <p>Lorem Ipsum dolroin gravida nibh vel velit auctor aliquet. </p>
                        </div>
                     </li>
                     <li>
                        <i class="flaticon-price-tag"></i>
                        <div class="fl-inner">
                           <h4>eCommerce Ready</h4>
                           <p>Lorem Ipsum dolroin gravida nibh vel velit auctor aliquet. </p>
                        </div>
                     </li>
                     <li>
                        <i class="flaticon-new-file"></i>
                        <div class="fl-inner">
                           <h4>Easy to Customize</h4>
                           <p>Lorem Ipsum dolroin gravida nibh vel velit auctor aliquet. </p>
                        </div>
                     </li>
                  </ul>
               </div>
               <div class="col-md-4 col-sm-6 col-xs-12">
                  <ul class="features-right">
                     <li>
                        <i class="flaticon-pantone"></i>
                        <div class="fr-inner">
                           <h4>Limitless Colors</h4>
                           <p>Lorem Ipsum dolroin gravida nibh vel velit auctor aliquet. </p>
                        </div>
                     </li>
                     <li>
                        <i class="flaticon-cloud-computing"></i>
                        <div class="fr-inner">
                           <h4>Lifetime Update</h4>
                           <p>Lorem Ipsum dolroin gravida nibh vel velit auctor aliquet. </p>
                        </div>
                     </li>
                     <li>
                        <i class="flaticon-line-graph"></i>
                        <div class="fr-inner">
                           <h4>SEO Friendly</h4>
                           <p>Lorem Ipsum dolroin gravida nibh vel velit auctor aliquet. </p>
                        </div>
                     </li>
                     <li>
                        <i class="flaticon-coding"></i>
                        <div class="fr-inner">
                           <h4>Simple Clean Code</h4>
                           <p>Lorem Ipsum dolroin gravida nibh vel velit auctor aliquet. </p>
                        </div>
                     </li>
                  </ul>
               </div>
               <div class="col-md-4 wow fadeInRight" data-wow-delay="0.5" data-wow-duration="1s">
                  <div class="full">
                     <div class="center">
                        <img src="../assets/template/images/application_screen.png" alt="#" />
                     </div>
                  </div>
               </div>
            </div>
         </div>
      </section>
      <!-- end section -->
      <!-- section -->
      <section class="layout_padding gradiant_bg cross_layout">
         <div class="container">
            <div class="row">
               <div class="col-sm-12">
                  <div class="full text_align_center white_fonts">
                     <div class="heading_main center_head_border heading_style_1">
                        <h2>Easy <span>Steps</span></h2>
                     </div>
                  </div>
               </div>
            </div>
            <div class="row step_section">
               <div class="offset-xl-1 col-xl-10 col-md-12">
                  <div class="row">
                     <div class="col-lg-3 col-md-6 col-sm-12 col-xs-12">
                        <div class="step_blog arrow_right_step">
                           <div class="step_inner">
                              <i class="fa fa-diamond"></i><br>
                              <p>Go app store</p>
                           </div>
                        </div>
                     </div>
                     <div class="col-lg-3 col-md-6 col-sm-12 col-xs-12">
                        <div class="step_blog">
                           <div class="step_inner">
                              <i class="fa fa-user"></i><br>
                              <p>Create an Account</p>
                           </div>
                        </div>
                     </div>
                     <div class="col-lg-3 col-md-6 col-sm-12 col-xs-12">
                        <div class="step_blog">
                           <div class="step_inner">
                              <i class="fa fa-download"></i><br>
                              <p>Download & Install</p>
                           </div>
                        </div>
                     </div>
                     <div class="col-lg-3 col-md-6 col-sm-12 col-xs-12">
                        <div class="step_blog">
                           <div class="step_inner">
                              <i class="fa fa-thumbs-up"></i><br>
                              <p>Enjoy & Rate us!</p>
                           </div>
                        </div>
                     </div>
                  </div>
               </div>
            </div>
         </div>
      </section>
      <!-- end section -->
      <!-- section -->
      <section class="layout_padding">
         <div class="container">
            <div class="row">
               <div class="full">
                  <div class="row">
                     <div class="col-sm-12">
                        <div class="full text_align_center">
                           <div class="heading_main center_head_border heading_style_1">
                              <h2>Table price</h2>
                           </div>
                        </div>
                     </div>
                  </div>
               </div>
            </div>
            <div class="row">
               <div class="col-sm-12">
                  <div class="full" style="margin-top:10px;">
                     <div class="row">
                        <div class="col-sm-12 col-md-4">
                           <div class="table_price text_align_center">
                              <div class="table_price_head">
                                 <h5>Basic</h5>
                              </div>
                              <div class="table_price_cont">
                                 <div class="table_price_per">
                                    <p>$29.00<br>
                                       <small>/month</small>
                                    </p>
                                 </div>
                                 <div class="table_price_cont_bottm">
                                    <ul>
                                       <li>100 MB Disk Space</li>
                                       <li>2 Subdomains</li>
                                       <li>5 Email Accounts</li>
                                       <li>Customer Support 24/7</li>
                                    </ul>
                                 </div>
                              </div>
                              <div class="table_price_bottm"> <a class="bt_main" href="index.html">Buy now</a> </div>
                           </div>
                        </div>
                        <div class="col-sm-12 col-md-4">
                           <div class="active_price table_price text_align_center">
                              <div class="table_price_head">
                                 <h5>Standard</h5>
                              </div>
                              <div class="table_price_cont">
                                 <div class="table_price_per">
                                    <p>$39.00<br>
                                       <small>/month</small>
                                    </p>
                                 </div>
                                 <div class="table_price_cont_bottm">
                                    <ul>
                                       <li>100 MB Disk Space</li>
                                       <li>2 Subdomains</li>
                                       <li>5 Email Accounts</li>
                                       <li>Customer Support 24/7</li>
                                    </ul>
                                 </div>
                              </div>
                              <div class="table_price_bottm"> <a class="reverse_bt bt_main" href="index.html">Buy now</a> </div>
                           </div>
                        </div>
                        <div class="col-sm-12 col-md-4">
                           <div class="table_price text_align_center">
                              <div class="table_price_head">
                                 <h5>Profesional</h5>
                              </div>
                              <div class="table_price_cont">
                                 <div class="table_price_per">
                                    <p>$45.00<br>
                                       <small>/month</small>
                                    </p>
                                 </div>
                                 <div class="table_price_cont_bottm">
                                    <ul>
                                       <li>100 MB Disk Space</li>
                                       <li>2 Subdomains</li>
                                       <li>5 Email Accounts</li>
                                       <li>Customer Support 24/7</li>
                                    </ul>
                                 </div>
                              </div>
                              <div class="table_price_bottm"> <a class="bt_main" href="index.html">Buy now</a> </div>
                           </div>
                        </div>
                     </div>
                  </div>
               </div>
            </div>
         </div>
      </section>
      <!-- end section -->
      <!-- section -->
      <section class="contact_section">
         <div class="container-fluid">
            <div class="row">
               <div class="col-xs-12 col-sm-12 col-md-6" style="padding:0;">
                  <div class="full">
                     <div id="map"></div>
                  </div>
               </div>
               <div class="col-xs-12 col-sm-12 col-md-6" style="padding:0;">
                  <div class="full">
                     <div class="contact_form white_heading_border">
                        <div class="contact_form_inner">
                           <div class="full_heading white_fonts heading_main heading_style_1">
                              <h2>Contact <span>us</span></h2>
                           </div>
                           <p>Sed ut perspiciatis unde omnis iste natus error sit voluptatem accusantium doloremque laudantium, totam rem aperiam, eaque ipsa quae ab illo inventore veritatis et quasi architecto beatae vitae dicta sunt explicabo.</p>
                           <div class="form_contact">
                              <!-- form -->
                              <form action="index.html">
                                 <fieldset>
                                    <div class="field">
                                       <input type="text" name="name" placeholder="Your name" required="">
                                    </div>
                                    <div class="field">
                                       <input type="text" name="name" placeholder="Your phone" required="">
                                    </div>
                                    <div class="field">
                                       <input type="email" name="email" placeholder="Email" required="">
                                    </div>
                                    <div class="field">
                                       <textarea name="messager" placeholder="Messager" required=""></textarea>
                                    </div>
                                    <div class="field">
                                       <button class="field_bt">Send</button>
                                    </div>
                                 </fieldset>
                              </form>
                              <!-- end form -->
                           </div>
                        </div>
                     </div>
                  </div>
               </div>
            </div>
         </div>
      </section>
      <!-- end section -->
      <!-- footer -->
      <footer class="footer_style_2">
         <div class="footer_top">
            <div class="container">
               <div class="row">
                  <div class="col-xs-12 col-sm-6 col-md-6 col-lg-4 margin_bottom_30">
                     <div class="full width_9" style="margin-bottom:25px;"> <a href="index.html"><img class="img-responsive" width="250" src="../assets/template/images/logo.png" alt="#"></a> </div>
                     <div class="full width_9">
                        <p>Nemo enim ipsam voluptatem quia voluptas sit aspernatur aut odit aut fugit, sed quia consequuntur magni dolores eos qui ratione voluptatem sequi nesciunt.</p>
                     </div>
                     <div class="full width_9">
                        <p>the vero eos et accusamus et iusto odio dignissimos ducimus qui blanditiis praesentium voluptatum deleniti atque corrupti quos dolores et quas molestias excepturi sint occaecati..</p>
                     </div>
                  </div>
                  <div class="col-xs-12 col-sm-6 col-md-6 col-lg-3 margin_bottom_30">
                     <div class="full">
                        <div class="footer_blog_2 width_9">
                           <h3>Twitter Feed</h3>
                           <p><i class="fa fa-twitter"></i> Creative_Talent - 26 mins
                              Te invitamos a seguir la cta. de WEntrepreneur_ ¡Atrévete! #Emprendimiento #PyMES #Economía #Bussines #Negocios https://t.co/Y7tZMmxGHn
                           </p>
                           <p><i class="fa fa-twitter"></i> Creative_Talent - 26 mins
                              Te invitamos a seguir la cta. de WEntrepreneur_ ¡Atrévete! #Emprendimiento #PyMES #Economía #Bussines #Negocios https://t.co/Y7tZMmxGHn
                           </p>
                        </div>
                     </div>
                  </div>
                  <div class="col-xs-12 col-sm-6 col-md-6 col-lg-2 margin_bottom_30">
                     <div class="full">
                        <div class="footer_blog_2">
                           <h3>Social</h3>
                        </div>
                     </div>
                     <div class="full">
                        <ul class="footer-links">
                           <li><a href="#"><i class="fa fa-facebook"></i> 256 Likes</a></li>
                           <li><a href="#"><i class="fa fa-github"></i> 57+ Projects</a></li>
                           <li><a href="#"><i class="fa fa-twitter"></i> 1,258 Followers</a></li>
                           <li><a href="#"><i class="fa fa-pinterest"></i> 2538+ Pins</a></li>
                        </ul>
                     </div>
                  </div>
                  <div class="col-xs-12 col-sm-6 col-md-6 col-lg-3 margin_bottom_30">
                     <div class="full">
                        <div class="footer_blog_2 width_9">
                           <h3>Blog</h3>
                        </div>
                        <div class="blog_post_footer">
                           <div class="blog_post_img"> <img width="80" height="80" src="../assets/template/images/scr1.png" alt="#"> </div>
                           <div class="blog_post_cont">
                              <p class="date">July 22, 2015</p>
                              <p class="post_head">Round and round like a carousel</p>
                           </div>
                        </div>
                        <div class="blog_post_footer">
                           <div class="blog_post_img"> <img width="80" height="80" src="../assets/template/images/scr2.png" alt="#"> </div>
                           <div class="blog_post_cont">
                              <p class="date">July 22, 2015</p>
                              <p class="post_head">Round and round like a carousel</p>
                           </div>
                        </div>
                        <div class="blog_post_footer">
                           <div class="blog_post_img"> <img width="80" height="80" src="../assets/template/images/scr3.png" alt="#"> </div>
                           <div class="blog_post_cont">
                              <p class="date">July 22, 2015</p>
                              <p class="post_head">Round and round like a carousel</p>
                           </div>
                        </div>
                     </div>
                  </div>
               </div>
            </div>
         </div>
         <!-- footer bottom -->
         <div class="footer_bottom">
            <!-- <p>Dessigned and developed by <strong>html.design</strong></p> -->
			<p>© 2020 Cicadasing Technology LLC. All rights reserved.</p>
         </div>
      </footer>
  </div>
</template>
<style lang="scss">
@import "../assets/template/css/bootstrap.min.css";
@import "../assets/template/css/style.css";
@import "../assets/template/css/responsive.css";
@import "../assets/template/css/colors.css";
@import "../assets/template/css/animate.css";
// @import "../assets/template/font-awesome-4.7.0/css/font-awesome.min.css";
// .home {

// }
.menu-mobile{
   line-height: 28px;;
}
.download_bt{
   position:relative;
   &.ios{
      &:hover:after{
         opacity: 1;
      }
      &:after{
         position:absolute;
         // display:none;
         transition:ease 0.5s all;
         opacity: 0;
         content:' ';
         width: 148px;
         height:148px;
         left:0;
         top:50px;
         background:url("../assets/image/iosDownload.png");
         background-size:148px;
      }
   }
   &.android{
      &:hover:after{
         opacity: 1;
      }
      &:after{
         position:absolute;
         // display:none;
         transition:ease 0.5s all;
         opacity: 0;
         content:' ';
         width: 148px;
         height:148px;
         left:0;
         top:50px;
         background:url("../assets/image/androidDownload.png");
         background-size:148px;
      }
   }
}
</style>

<script>
// import "../assets/template/js/jquery.min.js";
// import "../assets/template/js/popper.min.js";
// import "../assets/template/js/wow.js";
// import "../assets/template/js/custom.js";
// import "../assets/template/js/bootstrap.min.js";
// import "";
export default {
  title: "Dingo Group",	
  data() {
    return {
    };
  },
  methods: {
  },
  mountedBefore(){
	  var map = document.createElement('script');
	  map.src = "https://maps.googleapis.com/maps/api/js?key=AIzaSyA8eaHt9Dh5H57Zh0xVTqxVdBFCvFMqFjQ&callback=initMap";
	  document.body.appendChild(map)
  }
};
</script>
